/** Shared neutral light-mode surfaces for the PrimeNG theme. */
export const FINANCE365_LIGHT_SURFACE = {
  0: '#ffffff',
  50: '#f8fafb',
  100: '#babcbe',
  200: '#e3e9eb',
  300: '#9fa9ad',
  400: '#778287',
  500: '#5b666b',
  600: '#465157',
  700: '#333d42',
  800: '#252d31',
  900: '#181e21',
  950: '#0f1416',
}

export const FINANCE365_THEME_EXTENSION = {
  semantic: {
    colorScheme: {
      light: {
        surface: FINANCE365_LIGHT_SURFACE,
      },
    },
  },
}
